import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';
import { toast } from 'react-toastify';

export const MODULE = 'Receivable';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'List', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/finance/receivable`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $create = ActionCreator.Async(MODULE, 'Create', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/finance/receivable`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id, params) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/finance/receivable/${id}`, params)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/finance/receivable/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $updatePartial = ActionCreator.Async(MODULE, 'UpdatePartial', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/finance/receivable/${id}/partial`, payload)
      .then((response) => {
        dispatch($updatePartial.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/finance/receivable/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});

export const $publish = ActionCreator.Async(MODULE, 'Publish', (id) => {
  return async (dispatch) => {
    dispatch($processing($publish.OPERATION));

    return await Rest.PUT(`${API_URL}/finance/receivable/${id}/publish`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($publish.OPERATION)));
  };
});

export const $emailReceivable = ActionCreator.Async(MODULE, 'EmailReceivable', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($emailReceivable.OPERATION));

    return await Rest.GET(`${API_URL}/finance/email/receivable/${id}`, payload)
      .then((response) => {
        toast.success("Berhasil mengirimkan email", {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });


        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        toast.error("Gagal mengirimkan email", {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false;
      })
      .finally(() => dispatch($done($emailReceivable.OPERATION)));
  };
});

export const $emailOutstandingOverdue = ActionCreator.Async(MODULE, 'EmailOutstandingOverdue', (payload) => {
  return async (dispatch) => {
    dispatch($processing($emailOutstandingOverdue.OPERATION));

    return await Rest.GET(`${API_URL}/finance/email/outstanding/overdue`, payload)
      .then((response) => {
        if (response?.message === 'success') {
          toast.success("Berhasil mengirimkan email", {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error("Gagal mengirimkan email", {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }

        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($emailOutstandingOverdue.OPERATION)));
  };
});

export const $emailWilltolate = ActionCreator.Async(MODULE, 'EmailWillToLate', (payload) => {
  return async (dispatch) => {
    dispatch($processing($emailWilltolate.OPERATION));

    return await Rest.GET(`${API_URL}/finance/email/willtolate`, payload)
      .then((response) => {
        if (response?.message === 'success') {
          toast.success("Berhasil mengirimkan email", {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error("Gagal mengirimkan email", {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }


        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($emailWilltolate.OPERATION)));
  };
});